import { recursiveGet } from 'lodash';

function getReferredToNetwork(referral) {
  return recursiveGet(referral, ['referred_to_network', 'referred_by_network'], {});
}

export default getReferredToNetwork;
